import Text from "_shared/text/text";

export default class FeeScheduleBillingCode extends Text {
  public static get Prototype(): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode("Prototype");
  }

  public static override fromJSON(
    value: string | object | boolean | number | null | undefined
  ): FeeScheduleBillingCode | null | undefined {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new Error("Cannot create FeeScheduleBillingCode from non-string value");
    return new FeeScheduleBillingCode(value);
  }

  public get isEmpty(): boolean {
    return this.value === "";
  }
}
